import Vue from "vue";
import Router from "vue-router";
import layout from "@/views/layout.vue";
import login from "@/views/login/login.vue";
import test from "@/views/test.vue";
import page404 from "@/views/404.vue";

//首页
import homepage from "@/views/homepage/homepage.vue";

// 基础配置
import roleManagement from "@/views/basic/roleManagement.vue";
import userManagement from "@/views/basic/userManagement.vue";
import menuManagement from "@/views/basic/menuManagement.vue";
import depaManagement from "@/views/basic/depaManagement.vue";

// 商品信息
import brandInfo from "@/views/commodity/brandInfo.vue";
import classInfo from "@/views/commodity/classInfo.vue";
import attriInfo from "@/views/commodity/attriInfo.vue";
import spuInfo from "@/views/commodity/spuInfo.vue";
import spuEdit from "@/views/commodity/spuEdit.vue";
import stageInfo from "@/views/commodity/stageInfo.vue";
import labelInfo from "@/views/commodity/labelInfo.vue";
import priceInfo from "@/views/commodity/priceInfo.vue";
import skuSpManage from "@/views/commodity/skuSpManage.vue";
import skuAreaManage from "@/views/commodity/skuAreaManage.vue"; // 列表-区域设置资金商
import skuAreaManageSet from "@/views/commodity/skuAreaManageSet.vue"; // 设置-区域设置资金商
import skuSpEdit from "@/views/commodity/skuSpEdit.vue";

import groupInfo from "@/views/other/groupInfo.vue";// 客户集团管理
import serviceInfo from "@/views/other/serviceInfo.vue";// 服务商
import serviceEdit from "@/views/other/serviceEdit.vue";// 服务商编辑

// 财务管理
import rebateImport from "@/views/finance/rebateImport.vue";
import rebateIncome from "@/views/finance/rebateIncome.vue";
import rebateExpend from "@/views/finance/rebateExpend.vue";
import walletImport from "@/views/finance/walletImport.vue";
import walletIncome from "@/views/finance/walletIncome.vue";
import walletExpend from "@/views/finance/walletExpend.vue";

// 资金商sku信息管理
import spSkuInfo from "@/views/commodity/spSkuInfo.vue";

// sku信息管理
import skuInfo from "@/views/skuInfo/index.vue";
import skuInfoList from "@/views/skuInfo/list.vue"
import skuInfoAdd from "@/views/skuInfo/add.vue"
import skuInfoDetail from "@/views/skuInfo/detail.vue"

// 仓库管理
import wareList from "@/views/warehouse/wareList.vue";
import wareAdd from "@/views/warehouse/wareAdd.vue";
import wareImport from "@/views/warehouse/wareImport.vue";
import wareDetail from "@/views/warehouse/wareDetail.vue";
import splitList from "@/views/warehouse/splitList.vue";
import splitImport from "@/views/warehouse/splitImport.vue";
import splitDetail from "@/views/warehouse/splitDetail.vue";
import inventory from "@/views/warehouse/inventory.vue";
import inventoryEdit from "@/views/warehouse/inventoryEdit.vue";
import inventoryLog from "@/views/warehouse/inventoryLog.vue";
import inventoryLogByProduct from "@/views/warehouse/inventoryLogByProduct.vue";
import orderList from "@/views/warehouse/orderList.vue";
import orderAdd from "@/views/warehouse/orderAdd.vue";
import orderDetail from "@/views/warehouse/orderDetail.vue";
import warehouseProduct from "@/views/warehouse/warehouseProduct.vue";
// 仓库选择入口
import warehouseEntry from "@/views/warehouse/warehouseEntry.vue";
import warehouseSource from "@/views/warehouse/source.vue";
import warehouseSourceEdit from "@/views/warehouse/sourceEdit.vue";

// 通知消息
import messageList from "@/views/message/messageList.vue";
import messageDetail from "@/views/message/messageDetail.vue";

// 配额管理
import allocProvince from "@/views/quota/allocProvince.vue";
import allocRetailer from "@/views/quota/allocRetailer.vue";
import allocRetailerGroup from "@/views/quota/allocRetailerGroup.vue";
import allocShipTo from "@/views/quota/allocShipTo.vue";

// 门店管理
import shop from "@/views/shop/index.vue";
import shopInfo from "@/views/shop/info/index.vue";

// 资金商&服务商
import merchant from "@/views/merchant/index.vue";
import merchantCreate from "@/views/merchant/manage/create.vue";
import merchantList from "@/views/merchant/manage/list.vue";
import merchantDetail from "@/views/merchant/manage/detail.vue";
import merchantArea from "@/views/merchant/manage/area.vue"; // 覆盖范围
import merchantRelationList from "@/views/merchant/relation/list.vue";
import merchantRelationCreate from "@/views/merchant/relation/create.vue";

//优惠券
import coupon from "@/views/coupon/index.vue";
import couponTemplateList from "@/views/coupon/template/list.vue";
import couponTemplateCreate from "@/views/coupon/template/create.vue";
import couponApplyCreate from "@/views/coupon/apply/create.vue";
import couponApplyList from "@/views/coupon/apply/list.vue";
import couponDistribList from "@/views/coupon/use/list.vue";
import couponRuleCtl from "@/views/coupon/rulectl/busictl.vue";

// 门店信息
import store from '@/views/store/index.vue';
import storeManage from '@/views/store/storeManage.vue';
import storeEdit from '@/views/store/storeEdit.vue';
import storeDetail from '@/views/store/storeDetail.vue';
import storeAdd from '@/views/store/storeAdd.vue';
import invoiceList from '@/views/store/invoiceList.vue';
import invoiceDetail from '@/views/store/invoiceDetail.vue';

//门店任务
import shopTask from '@/views/shopTask/index.vue';
import shopDisplay from '@/views/shopTask/shopDisplay.vue';
import shopDisplayDetail from '@/views/shopTask/shopDisplayDetail.vue';
import shopPos from '@/views/shopTask/shopPos.vue';
import shopPosDetail from '@/views/shopTask/shopPosDetail.vue';

// 订单管理
import order from "@/views/order/index.vue";
import orderManageList from "@/views/order/list.vue";
import orderManageDetail from "@/views/order/detail.vue";
import orderDelivery from "@/views/order/delivery.vue";
import orderDeliveryDetail from '@/views/order/deliveryDetail.vue'
import orderMap from '@/views/order/orderMap.vue'

import sys from '@/views/sys/index.vue'
import sql from '@/views/sys/sql.vue'

// 余额管理
import wallCash from "@/views/shop/wallet/cash.vue";
import wallRebate from "@/views/shop/wallet/rebate.vue";

//任务管理
import taskManage from '@/views/task/taskManage.vue';
import taskAdd from '@/views/task/taskAdd.vue';
import taskEdit from '@/views/task/taskEdit.vue';

import datax from '@/views/datax/index.vue';
import template from '@/views/datax/template.vue';
import instance from '@/views/datax/instance.vue';

import templateAdd from '@/views/datax/templateAdd.vue';
import instanceAdd from '@/views/datax/instanceAdd.vue';

import report from '@/views/report/index.vue';
import spInfoAdd from '@/views/report/spInfoAdd.vue';
import spInfo from '@/views/report/spInfo.vue';
import spData from '@/views/report/spData.vue';
import sllIn from '@/views/report/slleInImport.vue';
import spStock from '@/views/report/stockImport.vue';
import buildReport from '@/views/report/buildReport.vue';
import reportData from '@/views/report/data.vue';

import spTotal from '@/views/report/spTotal.vue';
import settleDate from '@/views/report/settleDate.vue';
import addSettle from '@/views/report/addSettleDate.vue';

import invReport from '@/views/invreport/index.vue';
import forecast from '@/views/invreport/forecast.vue';
import forecastUpload from '@/views/invreport/forecastUpload.vue';
import actual from '@/views/invreport/actual.vue';
import actualUpload from '@/views/invreport/actualUpload.vue';
import psi from '@/views/invreport/psi.vue';
import psiUpload from '@/views/invreport/psiUpload.vue';
import summary from '@/views/invreport/summary.vue';
import inv from '@/views/invreport/inv.vue';
import invEdit from '@/views/invreport/invEdit.vue';
import buildInv from '@/views/invreport/buildInv.vue';
import invCategory from '@/views/invreport/category.vue';
import invCategoryAdd from '@/views/invreport/categoryAdd.vue';
import shortName from '@/views/invreport/shortName.vue';
import shortNameAdd from '@/views/invreport/shortNameAdd.vue';
import invMeta from '@/views/invreport/meta.vue';
import invMetaAdd from '@/views/invreport/metaAdd.vue';

import grade from '@/views/invreport/grade.vue';
import gradeMap from '@/views/invreport/gradeMap.vue';
import gradeGroup from '@/views/invreport/gradeGroup.vue';


// 素材管理
import content from "@/views/content/index.vue";
import contentList from '@/views/content/list.vue';
import materialList from '@/views/content/materialList.vue';
import advList from '@/views/content/advList.vue';

//物料管理
import material from "@/views/material/index.vue";
import materManList from "@/views/material/list.vue";
import activationList from "@/views/material/activationList.vue";
import scanList from "@/views/material/scanList.vue";
import frmLossList from "@/views/material/frmLossList.vue";
import materialAdd from "@/views/material/add.vue";
import scanDetail from "@/views/material/scanDetail.vue";
import frmLossDetail from "@/views/material/frmLossDetail.vue";
import activaDetail from "@/views/material/activaDetail.vue";
import materDetial from "@/views/material/materDetial.vue";

Vue.use(Router);
const originPush = Router.prototype.push
const originReplace = Router.prototype.replace
Router.prototype.push = function (location, onComplete, onAbort) {
  if (onComplete === undefined && onAbort === undefined) {
    return originPush.call(this, location, onComplete, onAbort).catch(() => {
    })
  } else {
    originPush.call(this, location, onComplete, onAbort)
  }
}
Router.prototype.replace = function (location, onComplete, onAbort) {
  if (onComplete === undefined && onAbort === undefined) {
    return originReplace.call(this, location, onComplete, onAbort).catch(() => {
    })
  } else {
    originReplace.call(this, location, onComplete, onAbort)
  }
}

const router = new Router({
  routes: [
    {
      path: "/",
      name: "layout",
      component: layout,
      redirect: '/homepage',// 重定位后页面加载的页面
      children: [
        {
          path: "/homepage",
          meta: {
            noAuth: true
          },
          name: "homepage",
          component: homepage
        },
        {
          path: "/roleManagement",
          name: "roleManagement",
          component: roleManagement
        },
        {
          path: "/userManagement",
          name: "userManagement",
          component: userManagement
        },
        {
          path: "/menuManagement",
          name: "menuManagement",
          component: menuManagement
        },
        {
          path: "/depaManagement",
          name: "depaManagement",
          component: depaManagement
        },
        {
          path: "/brandInfo",
          name: "brandInfo",
          component: brandInfo
        },
        {
          path: "/classInfo",
          name: "classInfo",
          component: classInfo
        },
        {
          path: "/attriInfo",
          name: "attriInfo",
          component: attriInfo
        },
        {
          path: "/spuInfo",
          name: "spuInfo",
          component: spuInfo
        },
        {
          path: "/spuEdit",
          name: "spuEdit",
          component: spuEdit
        },
        {
          path: "/skuInfo",
          // name: "skuInfo",
          component: skuInfo,
          children: [{
            path: "/",
            redirect: "list",
          }, {
            path: "list",
            name: "skuInfoList",
            component: skuInfoList
          }, {
            path: "add",
            name: "skuInfoAdd",
            component: skuInfoAdd
          }, {
            path: "detail",
            name: "skuInfoDetail",
            component: skuInfoDetail
          }]
        },
        {
          path: "/spSkuInfo",
          name: "spSkuInfo",
          component: spSkuInfo,
        },
        {
          path: "/stageInfo",
          name: "stageInfo",
          component: stageInfo
        },
        {
          path: "/labelInfo",
          name: "labelInfo",
          component: labelInfo
        },
        {
          path: "/priceInfo",
          name: "priceInfo",
          component: priceInfo
        },
        {
          path: "/skuSpManage",
          name: "skuSpManage",
          component: skuSpManage
        },
        {
          path: "/skuAreaManage",
          name: "skuAreaManage",
          component: skuAreaManage
        },
        {
          path: "/skuAreaManageSet",
          name: "skuAreaManageSet",
          component: skuAreaManageSet
        },
        {
          path: "/skuSpEdit",
          name: "skuSpEdit",
          component: skuSpEdit
        },
        // 其他
        {
          path: "/groupInfo",
          name: "groupInfo",
          component: groupInfo
        },
        {
          path: "/serviceInfo",
          name: "serviceInfo",
          component: serviceInfo
        },
        {
          path: "/serviceEdit",
          name: "serviceEdit",
          component: serviceEdit
        },
        // 财务管理
        {
          path: "/rebateImport",
          name: "rebateImport",
          component: rebateImport
        },
        {
          path: "/rebateIncome",
          name: "rebateIncome",
          component: rebateIncome
        },
        {
          path: "/rebateExpend",
          name: "rebateExpend",
          component: rebateExpend
        },
        {
          path: "/walletImport",
          name: "walletImport",
          component: walletImport
        },
        {
          path: "/walletIncome",
          name: "walletIncome",
          component: walletIncome
        },
        {
          path: "/walletExpend",
          name: "walletExpend",
          component: walletExpend
        },
        // 仓库信息
        {
          path: "/wareList",
          name: "wareList",
          component: wareList
        },
        {
          path: "/wareAdd",
          name: "wareAdd",
          component: wareAdd
        },
        {
          path: "/wareImport",
          name: "wareImport",
          component: wareImport
        },
        {
          path: "/wareDetail",
          name: "wareDetail",
          component: wareDetail
        },
        // 仓库拆分规则
        {
          path: "/splitList",
          name: "splitList",
          component: splitList
        },
        {
          path: "/splitImport",
          name: "splitImport",
          component: splitImport
        },
        // 仓库盘点
        {
          path: "/splitDetail",
          name: "splitDetail",
          component: splitDetail
        },
        {
          path: "/inventory",
          name: "inventory",
          component: inventory
        },
        {
          path: "/inventoryEdit",
          name: "inventoryEdit",
          component: inventoryEdit
        },
        {
          path: "/inventoryLog",
          name: "inventoryLog",
          component: inventoryLog
        },
        {
          path: "/inventoryLogByProduct",
          name: "inventoryLogByProduct",
          component: inventoryLogByProduct
        },
        {
          path: "/warehouse/entry",
          name: "/warehouseEntry",
          component: warehouseEntry
        },
        {
          path: "/warehouse/source",
          name: "/warehouseSource",
          component: warehouseSource
        },
        {
          path: "/warehouse/sourceEdit",
          name: "/warehouseSourceEdit",
          component: warehouseSourceEdit
        },
        // 采购单生成
        {
          path: "/orderList",
          name: "orderList",
          component: orderList
        },
        {
          path: "/orderAdd",
          name: "orderAdd",
          component: orderAdd
        },
        {
          path: "/orderDetail",
          name: "orderDetail",
          component: orderDetail
        },
        {
          path: "/warehouseProduct",
          name: "warehouseProduct",
          component: warehouseProduct
        },
        // 通知消息
        {
          path: "/messageList",
          name: "messageList",
          component: messageList,
        },
        {
          path: "/messageDetail",
          name: "messageDetail",
          component: messageDetail
        },
        // 配额管理
        {
          path: "/allocProvince",
          name: "allocProvince",
          component: allocProvince
        },
        {
          path: "/allocRetailer",
          name: "allocRetailer",
          component: allocRetailer
        },
        {
          path: "/allocRetailerGroup",
          name: "allocRetailerGroup",
          component: allocRetailerGroup
        },
        {
          path: "/allocShipTo",
          name: "allocShipTo",
          component: allocShipTo
        },
        // 门店管理
        {
          path: "/shop",
          name: "shop",
          component: shop,
          children: [{
            path: "info",
            name: "shopInfo",
            component: shopInfo
          }]
        },
        // 资金商&服务商相关
        {
          path: "/merchant",
          name: "merchant",
          component: merchant,
          children: [{
            path: "list",
            name: "merchantList",
            component: merchantList
          }, {
            path: "create",
            name: "merchantCreate",
            component: merchantCreate
          }, {
            path: "detail",
            name: "merchantDetail",
            component: merchantDetail
          }, {
            path: "area",
            name: "merchantArea",
            component: merchantArea
          }, {
            path: "relation",
            name: "merchantRelationList",
            component: merchantRelationList
          },
          {
            path: "relationCreate",
            name: "merchantRelationCreate",
            component: merchantRelationCreate

          }]
        },
        //优惠券
        {
          path: "/coupon",
          name: "coupon",
          component: coupon,
          children: [
            {
              path: "template/list",
              name: 'coupon_template_list',
              component: couponTemplateList
            },
            {
              path: "template/create",
              name: 'coupon_template_create',
              component: couponTemplateCreate
            }, {
              path: "apply/create",
              name: 'coupon_apply_create',
              component: couponApplyCreate
            }, {
              path: "apply/list",
              name: 'coupon_apply_list',
              component: couponApplyList
            }, {
              path: "use/list",
              name: 'coupon_distrib_List',
              component: couponDistribList
            }
            // , {
            //   path: "rulectl/busictl",
            //   name: 'coupon_rule_ctl',
            //   component: couponRuleCtl
            // }
          ]
        },
        // 门店信息
        {
          path: "/store",
          name: "store",
          component: store,
          children: [
            {
              path: "manage",
              name: "storeManage",
              component: storeManage,
              meta: {
                menu: [{// 自定义数据格式
                  father: "/store/manage",
                  path: '',
                  name: '渠道管理',
                }, {
                  path: '/store/manage',
                  name: '门店列表',
                }]
              }
            },
            {
              path: "edit",
              name: "storeEdit",
              component: storeEdit
            },
            {
              path: "detail",
              name: "storeDetail",
              component: storeDetail
            },
            {
              path: "add",
              name: "storeAdd",
              component: storeAdd,
              meta: {
                menu: [{// 自定义数据格式
                  father: "/store/manage",
                  path: '',
                  name: '渠道管理',
                }, {
                  path: '/store/manage',
                  name: '门店列表',
                }, {
                  path: '/store/add',
                  name: '基础信息',
                }]
              }
            },
            // 发票列表
            {
              path: "invoiceList",
              name: "invoiceList",
              component: invoiceList
            }, {
              path: "invoiceDetail",
              name: "invoiceDetail",
              component: invoiceDetail
            }
          ]
        },
        // 门店陈列
        {
          path: "/shopTask",
          name: "shopTask",
          component: shopTask,
          children: [
            {
              path: "shopDisplay",
              name: "shopDisplay",
              component: shopDisplay
            },
            {
              path: "shopDisplay/detail",
              name: "shopDisplayDetail",
              component: shopDisplayDetail
            },
            {
              path: "shopPos",
              name: "shopPos",
              component: shopPos
            },
            {
              path: "shopPos/detail",
              name: "shopPosDetail",
              component: shopPosDetail
            },
          ]
        },
        // 订单管理
        {
          path: "/order",
          name: "order",
          component: order,
          children: [{
            path: "list",
            name: "orderManageList",
            component: orderManageList
          }, {
            path: "detail",
            name: "orderManageDetail",
            component: orderManageDetail
          }, {
            path: "delivery",
            name: "orderDelivery",
            component: orderDelivery
          }, {
            path: "deliveryDetail",
            name: "orderDeliveryDetail",
            component: orderDeliveryDetail
          }, {
            path: "map",
            name: "map",
            component: orderMap
          }]
        },
        // 钱包余额
        {
          path: "/wallet/cash",
          name: "wallCash",
          component: wallCash
        },
        {
          path: "/wallet/rebate",
          name: "wallRebate",
          component: wallRebate
        },
        {
          path: "/taskManage",
          name: "taskManage",
          component: taskManage
        }, {
          path: "/taskManage/add",
          name: "taskAdd",
          component: taskAdd
        }, {
          path: "/taskManage/edit",
          name: "taskEdit",
          component: taskEdit
        }
        , {
          path: "/datax",
          name: "datax",
          component: datax,
          children: [{
            path: "template",
            name: "template",
            component: template
          }, {
            path: "instance",
            name: "instance",
            component: instance
          }, {
            path: "template/add",
            name: "templateAdd",
            component: templateAdd
          }, {
            path: "instance/add",
            name: "instanceAdd",
            component: instanceAdd
          }]
        },
        {
          path: "/sys",
          name: "sys",
          component: sys,
          children: [{
            path: "sql",
            name: "sql",
            component: sql
          }]
        },
        {
          path: "/inv",
          name: "invReport",
          component: invReport,
          children: [{
            path: "gradeGroup",
            name: "gradeGroup",
            component: gradeGroup
          }, {
            path: "grade",
            name: "grade",
            component: grade
          }, {
            path: "gradeMap",
            name: "gradeMap",
            component: gradeMap
          },
          {
            path: "meta",
            name: "invMeta",
            component: invMeta
          }, {
            path: "metaAdd",
            name: "invMetaAdd",
            component: invMetaAdd
          },
          {
            path: "category",
            name: "invCategory",
            component: invCategory
          }, {
            path: "category/add",
            name: "invCategoryAdd",
            component: invCategoryAdd
          }, {
            path: "shortName",
            name: "shortName",
            component: shortName
          }, {
            path: "shortName/add",
            name: "shortNameAdd",
            component: shortNameAdd
          }, {
            path: "build",
            name: "buildInv",
            component: buildInv
          }, {
            path: "inv",
            name: "inv",
            component: inv
          }, {
            path: "invEdit",
            name: "invEdit",
            component: invEdit
          }, {
            path: "forecast",
            name: "forecast",
            component: forecast
          }, {
            path: "forecastUpload",
            name: "forecastUpload",
            component: forecastUpload
          }, {
            path: "psi",
            name: "psi",
            component: psi
          }, {
            path: "psiUpload",
            name: "psiUpload",
            component: psiUpload
          }, {
            path: "actual",
            name: "actual",
            component: actual
          }, {
            path: "actualUpload",
            name: "actualUpload",
            component: actualUpload
          }, {
            path: "summary",
            name: "summary",
            component: summary
          }]
        },
        {
          path: "/report",
          name: "report",
          component: report,
          children: [{
            path: "spInfo",
            name: "spInfo",
            component: spInfo
          }, {
            path: "spInfoAdd",
            name: "spInfoAdd",
            component: spInfoAdd
          }, {
            path: "spData",
            name: "spData",
            component: spData
          }, {
            path: "sllIn",
            name: "sllIn",
            component: sllIn
          }, {
            path: "spStock",
            name: "spStock",
            component: spStock
          }, {
            path: "build",
            name: "build",
            component: buildReport
          }, {
            path: "data",
            name: "data",
            component: reportData
          }, {
            path: "settle",
            name: "settle",
            component: settleDate
          }, {
            path: "addSettle",
            name: "addSettle",
            component: addSettle
          }, {
            path: "spTotal",
            name: "spTotal",
            component: spTotal
          }]
        },
        // 资源管理
        {
          path: "/content",
          // name: "content",
          component: content,
          children: [
            {
              path: "/",
              redirect: "list",
            }, {
              path: "list",
              name: "contentList",
              component: contentList
            },
            {
              path: "materialList",
              name: "materialList",
              component: materialList
            },
            {
              path: "advList",
              name: "advList",
              component: advList
            },
          ]
        },
        // 物料管理
        {
          path: "/material",
          // name: "material",
          component: material,
          children: [
            {
              path: "/",
              redirect: "list",
            }, {
              path: "list",
              name: "materManList",
              component: materManList
            },
            {
              path: 'activationList',
              name: "activationList",
              component: activationList
            }, {
              path: 'scanList',
              name: "scanList",
              component: scanList
            }, {
              path: 'frmLossList',
              name: "frmLossList",
              component: frmLossList
            }, {
              path: 'materialAdd',
              name: "materialAdd",
              component: materialAdd
            }, {
              path: 'scanDetail',
              name: "scanDetail",
              component: scanDetail
            }, {
              path: 'frmLossDetail',
              name: "frmLossDetail",
              component: frmLossDetail
            }, {
              path: 'activaDetail',
              name: "activaDetail",
              component: activaDetail
            }, {
              path: 'materDetial',
              name: "materDetial",
              component: materDetial
            }
          ]
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/test",
      name: "test",
      meta: {
        noAuth: true
      },
      component: test
    },
    {
      path: "/404",
      name: "404",
      meta: {
        noAuth: true
      },
      component: page404
    }
  ],
  mode: "hash" // mode 设置为history ，去掉地址栏上的 # 号
});
router.beforeEach((to, from, next) => {
  if (to.path === "/login") return next();
  //获取token
  const tokenStr = window.sessionStorage.getItem("token");
  if (!tokenStr) return next("/login");

  next()

  // // TODO:
  // let menus = window.sessionStorage.getItem("menus");
  // menus = JSON.parse(decodeURIComponent(menus))
  // // 根据路由元信息判断是否需要控制权限
  // if(to.matched.some(record => record.meta.noAuth)){
  //   next() // 确保一定要调用 next()
  // }else{
  //   if(menus && menus.length){
  //     // console.log(to.path, menus)
  //     const hasPermisson = checkPermisson(to.path, menus)
  //     if(hasPermisson){
  //       next();
  //     }else{
  //       next("/404")
  //     }
  //   }else{
  //     next("/login");
  //   }
  // }
});

function checkPermisson(path, menus) {
  return menus.some(menu => {
    // console.log(path, menu.url)
    return path === menu.url
  })
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js